import type { Affectation } from '@/models/types';
import { IconCheck, IconClock, IconX } from '@tabler/icons-react';
import type { ComponentType } from 'react';

export const AFFECTATION_STATUSES: Affectation['status'][] = ['draft', 'published', 'archived'];

export const STATUS_COLOR: Record<Affectation['status'], string> = {
  published: 'green',
  draft: 'yellow',
  archived: 'red',
};

export const STATUS_ICON: Record<Affectation['status'], ComponentType<{ size?: number }>> = {
  published: IconCheck,
  draft: IconClock,
  archived: IconX,
};
